module.exports = __webpack_public_path__ + "static/img/fm.59c5190c.svg";